import { render, staticRenderFns } from "./ListKontoItem.vue?vue&type=template&id=5e8c73d2&scoped=true&"
import script from "./ListKontoItem.vue?vue&type=script&lang=js&"
export * from "./ListKontoItem.vue?vue&type=script&lang=js&"
import style0 from "./ListKontoItem.vue?vue&type=style&index=0&id=5e8c73d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c73d2",
  null
  
)

component.options.__file = "ListKontoItem.vue"
export default component.exports